export const findDuplicates = (array) => { return new Set(array).size !== array.length; };

export const removeDuplicates = (array) => { return [...new Set(array)]; };

export const compareArrays = (array1, array2) => {
	array1.length === array2.length && array1.every((element, index) => { return element === array2[index]; });
};
